module.exports = __webpack_public_path__ + "img/review-5.5fc9d1ba.jpg";